import instanceAxios from "./intanceAxios"



export const taskScheduledService = {
    createGroupScheduled: async (groupScheduled) => await instanceAxios.post('/otask/group-scheduled/', groupScheduled),
    getGroupScheduledByHash: async (hash) => await instanceAxios.get(`/otask/group-scheduled/`, { params: { hash_code: hash } }),
    updateGroupScheduled: async (groupScheduled) => await instanceAxios.put('/otask/group-scheduled/', groupScheduled),
    getAllGroupScheduled: async (params) => await instanceAxios.get('/otask/group-scheduled-all/', { params }),
    deleteGroupScheduled: async (id) => await instanceAxios.delete(`/otask/group-scheduled/`, { params: { group_scheduled_id: id } }),

    //TASKS
    createTask: async (task) => await instanceAxios.post('/otask/task-scheduled/', task),
    updateTask: async (task) => await instanceAxios.put('/otask/task-scheduled/', task),
    deleteTaskTemplate: async (hash_code) => await instanceAxios.delete(`/otask/task-scheduled/`, { params: { hash_code: hash_code } }),

    //PROGRAMAR LA TAREA TEMPLATE
    scheduleTaskTemplate: async (programTask) => await instanceAxios.post('/otask/task-scheduled-program/', programTask), 
    reprogramTaskTemplate: async (programTask) => await instanceAxios.put('/otask/task-scheduled-program/', programTask),
    deleteProgramTask: async (id) => await instanceAxios.delete(`/otask/task-scheduled-program/`, { params: { task_id: id } }),
}